import { Grid } from '@mui/material';

import MedicalHistoryFields from './MedicalHistoryFields';
import MedicalSensoryFields from './MedicalSensoryFields';

import type { MedicalInfoFieldsProps } from './types';

export default function MedicalInfoFields({
  formik,
  disabled,
  saveFieldOnBlur,
  areScreeningDatesRequired,
}: MedicalInfoFieldsProps) {
  return (
    <Grid container spacing={2}>
      <MedicalHistoryFields
        disabled={disabled}
        formik={formik}
        saveFieldOnBlur={saveFieldOnBlur}
      />
      <MedicalSensoryFields
        areScreeningDatesRequired={areScreeningDatesRequired}
        disabled={disabled}
        formik={formik}
        saveFieldOnBlur={saveFieldOnBlur}
      />
    </Grid>
  );
}
